import temp from './temp'

export default {
  ...temp
}
